import { DeletePartyInput19hgu5jgthqub as DeletePartyInput } from './schema/type/DeletePartyInput.mjs';
import { DeletePartyMutationn87apg3zfg0d as DeletePartyMutation } from './schema/DeletePartyMutation.mjs';
import { voidResult3hb4jxf0f2mcw as voidResult } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/VoidResult.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0_safe_receiver = (yield* this.t6s(new (DeletePartyMutation())(new (DeletePartyInput())(command.g2l_1)), $completion)).b45_1;
  // Inline function 'kotlin.let' call
  var tmp$ret$2 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q6g_1) === true;
  return voidResult(tmp$ret$2);
}
var SdkDeletePartyCommandDispatcherClass;
function SdkDeletePartyCommandDispatcher() {
  if (SdkDeletePartyCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkDeletePartyCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkDeletePartyCommandDispatcherClass = $;
  }
  return SdkDeletePartyCommandDispatcherClass;
}
//region block: exports
export {
  SdkDeletePartyCommandDispatcher as SdkDeletePartyCommandDispatcher27loij2ye5nr9,
  perform as perform39szuk57ufmau,
};
//endregion

//# sourceMappingURL=SdkDeletePartyCommandDispatcher.mjs.map
